import "./PrivacyContent.css"

export default function PrivacyContent() {
    return (
        <div>
            <h2>Privacy Content</h2>
            <div>
                <p>
                    <h5>Your privacy on the Accenture Portal</h5>
                    This website is administered by Accenture. The primary purpose of this site is to provide information and knowledge resources for Accenture employees. We want you to feel secure when visiting our site and are committed to maintaining your privacy when doing so. <br />
                    Before using and providing information through this site, we invite you to carefully read the below and our privacy statement.
                </p>
            </div>

            <div>
                <p>
                    <h5>What information do we gather?</h5>
                    Information in this site is gathered in two ways: indirectly (for example, through our site's technology) and directly (for example, when you provide information on various pages of the Accenture Portal). Although we do not generally seek to collect sensitive personal data through this site, we may do so in certain cases where we have the legal right to do so, or where you have expressly consented to this. <br />
                    One way that we collect information is through the use of cookies. Cookies are small files of information that save and retrieve information about your visit to this site – for example, how you entered our site, how you navigated through the site, and what information was of interest to you. Please read our <a href="https://www.accenture.com/be-en/company-cookies-similar-technology" target="_blank">cookies policy</a>  for further information on this.
                </p>
            </div>
            <div>
                <p>
                    <h5>How do we use your information?</h5>
                    We process your personal data as permitted by applicable data protection laws and our internal policies, including <a href="https://policies.accenture.com/policy/0090?rd=1&Country=United%20Kingdom" target="_blank">Accenture’s Global Data Privacy Policy 0090.</a> <br />
                    We analyze your information to determine what is most effective about our site, to help us identify ways to improve it, and eventually, to determine how we can tailor our site to make it more effective for you and other users. We may also use your information for certain other purposes, where we have the legal right to do so, such as complying with requests from public authorities or conducting internal investigations.
                </p>
            </div>
            <div>
                <p>
                    <h5>Will we share this with outside parties?</h5>
                    As a global organization, information we collect may be transferred internationally throughout Accenture's worldwide organization. In addition, we may at times share your information with certain third parties, such as our service providers.
                </p>
            </div>
            <div>
                <p>
                    <h5>How do we protect your information?</h5>
                    The protection of your information is important to us. We will process your information in accordance with applicable data protection legislation, and will take appropriate steps to maintain the security of this site.
                </p>
            </div>
            <div>
                <p>
                    <h5>Where can I find further information on this?</h5>
                    You can find further information on how and for what purposes we use your information, and on what rights you have in relation to your information, in our <a href="https://in.accenture.com/protectingaccenture/data-security/5422-2/" target="_blank">privacy statement.</a>
                </p>
            </div>
        </div>
    )
}